import React from 'react'
import { InviteListRow, InvitationStatus } from 'types/invite.types'
import { getAll, deleteOne } from 'apis/invites.api'
import DataTable from 'components/dataTable/dataTable2'

import { 
  Box,
  IconButton,
  useDisclosure
} from '@chakra-ui/react'

import { DeleteIcon } from '@chakra-ui/icons'

import { DataTableProps, DataTableQuery } from 'components/dataTable/dataTable2.types'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import SendInvitesDrawer from './SendInvitesDrawer'
import { useQueryClient, useMutation } from '@tanstack/react-query'

import {
  MdOutlineSend
} from 'react-icons/md';
import SearchBox from 'components/searchBox/SearchBox'
import { createColumnHelper, ColumnDef } from '@tanstack/react-table'
import dayjs from 'dayjs'

const formatStatusName = (status: InvitationStatus) => {
  switch (status) {
    case InvitationStatus.Pending:
      return 'Pending';
    case InvitationStatus.SignedUp:
      return 'Signed up';
    case InvitationStatus.Visited:
      return 'Visited';
    case InvitationStatus.EmailFailed:
      return 'Email Failed';
  }
}

const InvitesTable = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const btnRef = React.useRef()

  const queryClient = useQueryClient()
  const mutation = useMutation((id: string) => {
    return deleteOne(id)
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invites']})
    }
  })
  const { search } = useLocation()
  const { url, path } = useRouteMatch()
  const { push } = useHistory()

  const searchParams = new URLSearchParams(window.location.search);
  const columnHelper = createColumnHelper<InviteListRow>()
  const columns: Array<ColumnDef<InviteListRow, any>> = [
    columnHelper.accessor('invitedAt', {
      header: 'Invited At',
      cell: props => dayjs(props.getValue()).format('LLL'),
      size: 25
    }),
    columnHelper.accessor('name', {
      header: 'Name',
      cell: props => props.getValue(),
      size: 20
    }),
    columnHelper.accessor('email', {
      header: 'Email',
      cell: props => props.getValue(),
      size: 20
    }),
    columnHelper.accessor('code', {
      header: 'Signup Code',
      cell: props => props.getValue(),
      size: 15
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      cell: props => <div>{formatStatusName(props.getValue())}</div>,
      size: 15
    }),
    columnHelper.accessor('id', {
      header: '',
      cell: props => <IconButton aria-label='delete' 
        icon={<DeleteIcon/>} 
        onClick={async () => {
          mutation.mutate(props.getValue())
          // todo refresh 
        }} />,
      size: 5
    })
  ]
  
  const props: DataTableProps<InviteListRow, DataTableQuery> = {
    title: 'All Invites',
    columnsMeta: columns,
    cacheKey: 'invites',
    queryFn: getAll,
    menuOptions: [
      { label: 'Send Invites', icon: MdOutlineSend, onClick: () => {
        onOpen()
      } }
    ],
    onPageChange: (page => {
      let pushUrl = `${url}?page=${page}`
      const params = new URLSearchParams(search)
      if (params.has('searchKeyword'))
        pushUrl += '&searchKeyword=' + params.get('searchKeyword')
      push(pushUrl)
    })
  }
  return (
    <Box>
      <SearchBox 
        defaultValue={new URLSearchParams(search).get('searchKeyword')??''}
        onSearch={(value) => {
          window.location.href = `${url}?searchKeyword=${value}`
        }}/>
      <DataTable {...props} query={{ searchKeyword: new URLSearchParams(search).get('searchKeyword') ?? ''}}
        page={Number(searchParams.get('page') ?? 0)} 
      />
      <SendInvitesDrawer isOpen={isOpen} onClose={onClose} btnRef={btnRef} />
    </Box>
  )
}

export default InvitesTable;